import { MpBookmark } from "../../common/bookmark.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Bookmarks and vote
	const gamecardContainer = document.querySelector("#_gamecard_container");
	const ratingContainer = document.querySelector("#_rating_form");
	const bookmarks_container = document.querySelector("#_gamecard_bookmarks");
	if (gamecardContainer) {
		if (gamecardContainer.dataset.ct && gamecardContainer.dataset.id) {
			fetch(
				`/misc/bookmarks_and_vote/${gamecardContainer.dataset.ct}/${gamecardContainer.dataset.id}/`,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					cache: "no-cache",
				},
			)
				.then((response) => response.json())
				.then((data) => {
					const gamecard_bookmarks = data.gamecard_bookmarks;
					if (gamecard_bookmarks && bookmarks_container) {
						bookmarks_container.innerHTML = gamecard_bookmarks;
						init_gamecard_bookmarks();
					}
					const gamecard_rating_form = data.gamecard_rating_form;
					if (gamecard_rating_form && ratingContainer) {
						ratingContainer.innerHTML = gamecard_rating_form;
						import("../../common/rating.js").then(({ initRating }) => {
							initRating();
							// copy vote value in new label
							const scoreLabel = document.querySelector("#slider-label-score");
							const ratingOutput = document.querySelector("._rating_output");
							if (scoreLabel.textContent.length > 1) {
								ratingOutput.textContent = scoreLabel.textContent;
								ratingOutput.classList.add("active");
							}
							const observer = new MutationObserver(
								(mutationList, observer) => {
									for (const mutation of mutationList) {
										ratingOutput.textContent = scoreLabel.textContent;
										ratingOutput.classList.add("active");
									}
								},
							);
							observer.observe(scoreLabel, { childList: true });
						});
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		}
		// toggle vote form
		const ratingButton = document.querySelector("#_rating_button");
		if (ratingButton) {
			ratingButton.addEventListener("click", (event) => {
				document.querySelector("#_rating_form").classList.toggle("d-none");
			});
		}
	}
});

function init_gamecard_bookmarks() {
	const game_follow = new MpBookmark(
		document.querySelector("#_gamecard_follow"),
		{
			message: document.querySelector("#_gamecard_follow .tab_label"),
			message_on: "Non seguire",
			message_off: "Segui",
			form: document.querySelector("#_gamecard_follow .bookmarks_form"),
		},
	);
}
